import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { AllListLabelValue, LabelValue } from '../models/liste.model';
import { Pack } from '../models/pack.model';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

export type ListName =
  | 'Activite'
  | 'ContributionBracket'
  | 'Departements'
  | 'Job'
  | 'LegalForms'
  | 'MembershipStatuses'
  | 'NAF'
  | 'SalesChannel'
  | 'Packs'
  | 'Products'
  | 'Marketings';

@Injectable({ providedIn: 'root' })
export class ListeService {
  __URL_API__ = `${environment.URL_API}`;

  private _http = inject(HttpClient);

  getListPack(): Observable<Pack[]> {
    return this._http.get<Pack[]>(this.__URL_API__ + 'api/FichePartenaire/GetListePacks').pipe(
      take(1),
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }

  getList(listName: ListName): Observable<LabelValue[]> {
    return this._http.get<AllListLabelValue>(this.__URL_API__ + 'api/liste').pipe(
      take(1),
      map((allListLabelValue: AllListLabelValue) => allListLabelValue.values[listName] || []),
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }

  getAllLists(): Observable<AllListLabelValue> {
    return this._http.get<AllListLabelValue>(this.__URL_API__ + 'api/liste').pipe(
      take(1),
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }
}
